import axios from "axios";
import { useToast } from "vue-toastification";
import router from "@/router";

// Crear una instancia de axios
//baseURL: "https://adminvia.viaverde.org.bo/api",
//baseURL: "http://localhost:8000/api" ,
const apiClient = axios.create({
  baseURL: "https://adminvia.viaverde.org.bo/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Agregar un interceptor a la instancia de axios para incluir el token en cada solicitud si está presente
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    const excludePaths = ["/login", "/register"];
    
    // Excluir las rutas de login y register
    if (token && !excludePaths.some((path) => config.url.endsWith(path))) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const excludedUrls = [
  "/login",
  "/register",
  "/verify-password",
  "/forgot-password",
  "/guia-pdf/download-guia-pdf",
  "/validate-email-code",
];

let isForcingLogout = false;

function forceLogoutAndRedirect(optionalMessage) {
  if (isForcingLogout) return; // evita duplicados
  isForcingLogout = true;

  const toast = useToast();

  // Mensaje por defecto (o el que venga del backend)
  toast.error(
    optionalMessage ||
      "Su sesión ha expirado, por favor inicie sesión nuevamente.",
    { position: "top-center" }
  );

  // Limpieza de credenciales
  localStorage.removeItem("auth_token");
  localStorage.removeItem("user");
  localStorage.removeItem("company");

  // Enviar SIEMPRE al login sin recordar la ruta anterior
  router.replace({ name: "login" }).finally(() => {
    // libera el candado después de un pequeño tiempo
    setTimeout(() => (isForcingLogout = false), 300);
  });
}

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const configUrl = error.config?.url ?? "";
    const isExcluded = excludedUrls.some((excluded) =>
      configUrl.startsWith(excluded)
    );

    if (isExcluded) {
      // No hacemos nada especial en endpoints de auth/descargas públicas
      return Promise.reject(error);
    }

    const status = error.response?.status;
    const rawMessage = error.response?.data?.message ?? "";
    const message = String(rawMessage).toLowerCase();

    // Patrones comunes desde tu backend: "unauthenticated", "unauthorized", "token ha expirado", etc.
    const tokenExpiredHints = [
      "unauthenticated",
      "unauthorized",
      "token expired",
      "token ha expirado",
      "token_expired",
      "jwt expired",
    ];

    if (
      status === 401 &&
      tokenExpiredHints.some((hint) => message.includes(hint))
    ) {
      // Forzamos logout + redirección al login (sin recordar origen)
      forceLogoutAndRedirect(error.response?.data?.message);
      // Importante: rechazamos el error para que quien llamó pueda manejarlo si quiere
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
